import { getEnvironmentConfig } from '../configHelper.js';
const definition = {
    base: {
        focus: ['cXyiFj3QoYM8nNy2d'],
        bunte: [],
        chip: ['mT9H366ksKA5vEnNn'],
        fitforfun: ['DPJGy3YhhDgzRqqou'],
        finanzen100: ['RBe2ADxdWoFwbEFLx'],
        mittier: ['PYTTnLYHghfzmb5YA'],
        mitbeziehung: ['W8T37htswqdMpaEMD'],
        mitsternen: ['u2xem3YKBc6rErj8M'],
    },
    production: {
        focus: ['tpt96Yabt79qgxJYK'], //APP channel - PRODUCTION ID,
        bunte: ['JEmqXMZbDqfokooJX', 'DQcMnJ36q2LZTjeAM', 'NQMurDdbzBCpdtHvA'], // Two APP channels and Web - PRODUCTION ID,
        chip: ['mT9H366ksKA5vEnNn'], // WEB channel - PRODUCTION ID
        fitforfun: ['xwz3JQuJeCAG7AtQY'],
        finanzen100: ['jRbuRDK7NstYJQZYi'], //APP channel - PRODUCTION ID
        mittier: ['PYTTnLYHghfzmb5YA'],
        mitbeziehung: ['W8T37htswqdMpaEMD'],
        mitsternen: ['u2xem3YKBc6rErj8M'],
    },
};
export const cleverpushChannelsConfig = () => getEnvironmentConfig(definition);
export const getCleverpushChannelsForBrand = (brand) => cleverpushChannelsConfig()[brand]?.slice() ?? [];
//# sourceMappingURL=cleverpush.config.js.map